import React, { useState } from 'react';

import { Auth0ContextInterface, withAuth0 } from '@auth0/auth0-react';
import { Button, useToast } from '@chakra-ui/react';

import { createCheckoutSession } from '../../services/stripe';

const PurchaseButton = (props: {
  auth0: Auth0ContextInterface;
  stripePriceId: string;
  isSubscription: boolean;
}) => {
  const [state, setState] = useState({
    isLoading: false,
  });

  const toast = useToast();
  const failureToast = () =>
    toast({
      title: `Failed to create a checkout session.`,
      description: 'Reach out to hey@zopeful.com for help.',
      status: 'error',
      duration: 10000,
      isClosable: true,
    });

  const createCheckoutSessionForPurchase = async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isLoading: true,
      }));

      const token = await props.auth0.getAccessTokenSilently();

      const response = await createCheckoutSession(
        token,
        props.stripePriceId,
        props.isSubscription ? 'subscription' : 'payment',
        `${window.location.origin}${window.location.pathname}?purchase-success=true`,
        `${window.location.origin}${window.location.pathname}`,
      );

      const responseData = await response.json();

      if (!response.ok) {
        failureToast();
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      } else {
        window.location.href = responseData['url'];
      }
    } catch (error) {
      console.log(error);
      failureToast();
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  return (
    <Button
      onClick={createCheckoutSessionForPurchase}
      variant="solid"
      colorScheme="green"
      isDisabled={state.isLoading}
    >
      {props.isSubscription ? 'Subscribe' : 'Buy now'}
    </Button>
  );
};

export default withAuth0(PurchaseButton);
